<template>
  <WdsLabel
    subtle
    :xs="xs"
    :sm="sm"
    :gray="appearance.gray"
    :primary="appearance.primary"
    :success="appearance.success"
    :warning="appearance.warning"
    :icon="appearance.icon"
    :label="appearance.text"
    :data-test="dataTest"
  />
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { WdsLabel } from '@worksome/wds-components'
import { VerifiedWorkerComplianceStatus } from '@/gql/graphql'
import { $t } from '@/app-bootstrapping/SetUpInternationalization'

// Give status for a worker's review, which carries an icon, or completed for a single compliance, which does not.
const props = withDefaults(
  defineProps<{
    status?: VerifiedWorkerComplianceStatus
    completed?: boolean | null
    xs?: boolean
    sm?: boolean
    dataTest?: string
  }>(),
  { status: undefined, completed: false, xs: false, sm: false, dataTest: 'compliance-status-label' },
)

const tones = { gray: false, primary: false, success: false, warning: false, icon: undefined }

const appearance = computed(() => {
  switch (props.status) {
    case VerifiedWorkerComplianceStatus.Cleared:
      return { ...tones, success: true, icon: 'checkmark-filled' as const, text: $t('Cleared') }
    case VerifiedWorkerComplianceStatus.ChangesRequested:
      return { ...tones, warning: true, icon: 'undo' as const, text: $t('Changes requested') }
    case VerifiedWorkerComplianceStatus.ReadyToReview:
      return { ...tones, primary: true, icon: 'view' as const, text: $t('Ready to review') }
    case VerifiedWorkerComplianceStatus.Incomplete:
      return { ...tones, gray: true, icon: 'circle-dash' as const, text: $t('Incomplete') }
    default:
      return props.completed
        ? { ...tones, success: true, text: $t('Completed') }
        : { ...tones, warning: true, text: $t('Incomplete') }
  }
})
</script>
